import { makePickerWithState } from "@material-ui/pickers";
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  PasswordInput,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";

const DriverTypeCreate = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(`New map ${data.id} has been created`);
    redirect("/ivee-driver-types-prod");
    refresh();
  };

  return (
    <Create {...props} onSuccess={onSuccess}>
      <SimpleForm>
        <TextInput
          source="driverType"
          label="Driver Type"
          placeholder={"Text"}
        />
        <BooleanInput source="isStartScreen" label="Is Start Screen" />
        <BooleanInput source="isCarousel" label="Is Carousel" />
        <TextInput
          source="color"
          label="Color"
          placeholder={"For example #fff or #ffffff"}
        />
        <TextInput
          source="brandImageSource"
          label="Brand Image Source"
          placeholder={"Url of jpg or png image"}
        />
        <TextInput
          source="greetingText"
          label="Greeting text"
          placeholder={"Text"}
        />
        <TextInput
          source="subheadingText"
          label="Subheading Text"
          placeholder={"Text"}
        />
        <TextInput
          source="sessionTimeout"
          label="Session timeout"
          placeholder={"In minutes"}
        />
        <BooleanInput
          source="shouldPlayAds"
          label="Play Ads"
        />
        <NumberInput 
          source="maxAdDuration"
          label="Max Ad Duration (Seconds)"
        />
        <NumberInput 
          source="playsBetweenAds"
          label="Number of content plays between ads"
        />
      </SimpleForm>
    </Create>
  );
};

export default DriverTypeCreate;
